module.exports = __webpack_public_path__ + "static/media/continuous-assessment.eb9cf294.svg";